import config from '../config';

const BILL_DOWNLOAD_URL = `${config.apigee.baseUrl}/pge-bill-api/pdf/bills`;

export default function useDownloadBill() {
  /**
   * Downloads the bill with the given encryptedBillId, and returns a blob url to it
   */
  const downloadBill = async (
    encryptedBillId: string | null | undefined,
    isSummary: boolean = false,
    isNonDetailed: boolean = false,
  ) => {
    try {
      const result = await fetch(BILL_DOWNLOAD_URL, {
        method: 'POST',
        body: JSON.stringify({
          encryptedBillId,
          isSummary,
          isNonDetailed,
        }),
        headers: {
          'content-type': 'application/json',
        },
      });
      if (!result.ok) {
        throw new Error('Request failed');
      }

      const blob = await result.blob();
      if (blob.size === 0) {
        throw new Error('PDF was empty');
      }

      return URL.createObjectURL(blob);
    } catch (e) {
      return Promise.reject('Bill not found');
    }
  };

  return {
    downloadBill,
  };
}
